import { FormattedMessage } from 'react-intl';
import ErrorLayout from './ErrorLayout';

const ConnectionRefused = () => {
  return (
    <ErrorLayout
      title={
        <FormattedMessage
          id="error.connrefused.title"
          defaultMessage="Connection refused"
        />
      }
    >
      <>
        <p className="description">
          <FormattedMessage
            id="error.connrefused.body"
            defaultMessage="We apologize for the inconvenience, but the backend of the site you are accessing is not available right now. Please, try again later."
          />
        </p>
        <p>
          <FormattedMessage id="error.thanks" defaultMessage="Thank you." />
        </p>
      </>
    </ErrorLayout>
  );
};

export default ConnectionRefused;
